import React from "react";
import { Badge, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { FiCheckCircle, FiClock, FiRotateCcw } from "react-icons/fi";

const statusIcon = (status) => {
  switch (status) {
    case "SUCCESS":
    case "PAID":
    case "ACTIVE":
      return FiCheckCircle;
    case "REFUNDED":
    case "CANCELED":
      return FiRotateCcw;
    default:
      return FiClock;
  }
};

const ActivityRow = ({ item, formatDateTime, statusColor }) => {
  return (
    <HStack justify="space-between" align="flex-start">
      <HStack spacing={3} align="flex-start">
        <Icon as={statusIcon(item.status)} color="blue.500" mt={1} />
        <VStack align="flex-start" spacing={1}>
          <Text fontWeight="semibold">{item.title}</Text>
          <Text fontSize="sm" color="gray.600">
            {item.description}
          </Text>
        </VStack>
      </HStack>
      <VStack align="flex-end" spacing={1}>
        <Badge colorScheme={statusColor(item.status)}>{item.status}</Badge>
        <Text fontSize="xs" color="gray.500">
          {formatDateTime(item.timestamp)}
        </Text>
      </VStack>
    </HStack>
  );
};

export default ActivityRow;
